/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


// Funzione per controllare la complessità della password
        function checkPasswordStrength(password) {
            const minLength = 8;
            const hasUpperCase = /[A-Z]/.test(password);       // Verifica presenza di maiuscola
            const hasLowerCase = /[a-z]/.test(password);       // Verifica presenza di minuscola
            const hasNumber = /[0-9]/.test(password);          // Verifica presenza di numero
            const hasSpecialChar = /[!@#\$%\^\&*\)\(+=._-]/.test(password); // Verifica presenza di simbolo speciale
            
            return (
                password.length >= minLength &&
                hasUpperCase &&
                hasLowerCase &&
                hasNumber &&
                hasSpecialChar
            );
        }


// Event listener REGISTRAZIONE CHECK PASSWORD
if(document.getElementById("submitBtn")) {
      document.getElementById("submitBtn").addEventListener("click", function(event) {
        event.preventDefault(); 
      const passwordInput = document.querySelector("#create_customer input[type='password']");
      const errorMessage = document.getElementById("error-message");
    
      if (!checkPasswordStrength(passwordInput.value)) {
        errorMessage.style.display = "block";
      } else {
        errorMessage.style.display = "none";
        document.getElementById("create_customer").submit();
      }
    });
}
